import { useEffect, useState } from 'react';
import { Box, Flex } from "@chakra-ui/react";


import LaunchdeckTag from '../../../global/components/helper-components/components/LaunchdeckTag';
import TemplateCardOptionsButton from './TemplateCardOptionsButton';
import { getThisUserIdToken, redirectToNewPage } from '../../../global/helpers/global-helpers';

import '../../styles/vault.scss';
import { IoCalendarOutline } from "react-icons/io5";
import { formatDisplayDateOnly } from '../../../digital-sales-room/helpers/timestamp-display-helper';

export default function TemplateCardDisplay({ templateData, handleChangeUserActionRequired}) {
  const { dsrTemplateId, dsrTitle, dsrOwnerUsername, ownerUserId,
    status, dsrProperties, updatedAt,
  } = templateData || {};
  const { templateSettings } = dsrProperties || {}
  const { isOrgTemplate } = templateSettings || {};
  const [redirectLink, setRedirectLink] = useState('')
  const [showOptionButton, setShowOptionButton] = useState(false)
  const isAuthor = (ownerUserId === getThisUserIdToken()) ? true : false

  useEffect(() => {
    if (status) {
      switch (status) {
        case ('active'): {
          const truncatedTemplateId = dsrTemplateId?.replace("tmpl__", "");
          setRedirectLink(`/template/${truncatedTemplateId}`)
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [dsrTemplateId, status]);


  return (
    <Flex className="card-display"
      onMouseOver={() => setShowOptionButton(true)} onMouseOut={() => setShowOptionButton(false)}
    >

      <Box className="card-content-stack">
        <Flex align='center' justify='flex-start' gap={4}>
          <LaunchdeckTag bg='brandGreen.500' color='white' label='Template' />
          {(isOrgTemplate === false) && <LaunchdeckTag bg='brandDark.500' color='white' label='Private' />}
        </Flex>
        {isAuthor &&
          <Box opacity={showOptionButton ? '1.0' : '0'}>
            <TemplateCardOptionsButton
              dsrTitle={dsrTitle}
              dsrStatus={status}
              handleChangeUserActionRequired={handleChangeUserActionRequired}
              dsrTemplateId={dsrTemplateId}
              isAuthor={isAuthor}
            />
          </Box>
        }
      </Box>


      <Box w='100%'
        onClick={() => redirectToNewPage(redirectLink)} cursor='pointer'
      >
        <Box className="card-content-stack__column">
          <Box maxWidth={['60vw', '20vw']} className="dsr-title-display" title={dsrTitle ? dsrTitle : "-"}>
            {dsrTitle ? dsrTitle : "-"}
          </Box>
          <Flex className="stats-display">
            <Flex align='center'>
              <Box as={IoCalendarOutline} />
              <Box ml='0.25em'> {formatDisplayDateOnly(updatedAt)} </Box>
            </Flex>
          </Flex>
        </Box>

        <Box className="card-content-stack" mt='0.75em'>
          <Flex justify='flex-start' gap={2}>
            <Box fontSize='0.7em' color='gray.700'>Owned by {dsrOwnerUsername}</Box>
          </Flex>
        </Box>
      </Box>
    </Flex>
  )
}




